export type LoomMeetingNudgeReminderRequest = {
	handled: boolean;
};

export const LOOM_MEETING_NUDGE_REMINDER_REQUESTED_EVENT =
	'post-office:loom-meeting-nudge-reminder-requested';
export const LOOM_MEETING_NUDGE_SIDENAV_TRIGGER_ID = 'twc-loom-meeting-nudge-sidenav-trigger';
export const LOOM_MEETING_NUDGE_SIDENAV_SHOWN = 'twc-loom-meeting-nudge-sidenav-shown';
export const LOOM_MEETING_NUDGE_TITLE_SHOWN = 'twc-loom-meeting-nudge-title-shown';

export const requestLoomMeetingNudgeReminder = (): void => {
	globalThis.window?.dispatchEvent(
		new CustomEvent(LOOM_MEETING_NUDGE_REMINDER_REQUESTED_EVENT, {
			detail: { handled: false } satisfies LoomMeetingNudgeReminderRequest,
		}),
	);
};
